module.exports = __webpack_public_path__ + "static/Front5_Cropped-6e854f644aad3af3d6364f5ee6df4701.jpg";